var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoirTruckLength(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66927 11.1667C5.02289 11.1667 5.36203 11.0262 5.61208 10.7761C5.86213 10.5261 6.0026 10.187 6.0026 9.83333C6.0026 9.47971 5.86213 9.14057 5.61208 8.89052C5.36203 8.64048 5.02289 8.5 4.66927 8.5C4.31565 8.5 3.97651 8.64048 3.72646 8.89052C3.47641 9.14057 3.33594 9.47971 3.33594 9.83333C3.33594 10.187 3.47641 10.5261 3.72646 10.7761C3.97651 11.0262 4.31565 11.1667 4.66927 11.1667ZM11.3359 11.1667C11.6896 11.1667 12.0287 11.0262 12.2787 10.7761C12.5288 10.5261 12.6693 10.187 12.6693 9.83333C12.6693 9.47971 12.5288 9.14057 12.2787 8.89052C12.0287 8.64048 11.6896 8.5 11.3359 8.5C10.9823 8.5 10.6432 8.64048 10.3931 8.89052C10.1431 9.14057 10.0026 9.47971 10.0026 9.83333C10.0026 10.187 10.1431 10.5261 10.3931 10.7761C10.6432 11.0262 10.9823 11.1667 11.3359 11.1667Z",
    stroke: "#202020",
    strokeOpacity: 0.7,
    strokeMiterlimit: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 9.83333V2.9C9.33594 2.79391 9.29379 2.69217 9.21878 2.61716C9.14377 2.54214 9.04202 2.5 8.93594 2.5H1.73594C1.62985 2.5 1.52811 2.54214 1.45309 2.61716C1.37808 2.69217 1.33594 2.79391 1.33594 2.9V9.43333C1.33594 9.53942 1.37808 9.64116 1.45309 9.71618C1.52811 9.79119 1.62985 9.83333 1.73594 9.83333H3.1026M9.33594 9.83333H6.03594M9.33594 9.83333H10.0026M9.33594 4.5H13.0759C13.1533 4.50002 13.2289 4.52245 13.2937 4.56457C13.3586 4.60669 13.4098 4.6667 13.4413 4.73733L14.6346 7.42267C14.6573 7.47366 14.6691 7.52884 14.6693 7.58467V9.43333C14.6693 9.48586 14.6589 9.53788 14.6388 9.58641C14.6187 9.63494 14.5893 9.67903 14.5521 9.71618C14.515 9.75332 14.4709 9.78278 14.4223 9.80289C14.3738 9.82299 14.3218 9.83333 14.2693 9.83333H13.0026",
    stroke: "#202020",
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13.8334H13.8333M2 13.8334L3.16667 15.0001M2 13.8334L3.16667 12.6667M13.8333 13.8334L12.6667 15.0001M13.8333 13.8334L12.6667 12.6667",
    stroke: "#202020",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoirTruckLength);
export default __webpack_public_path__ + "static/media/iconoir_truck-length.0a99716296d99ea82486d3b7f409788f.svg";
export { ForwardRef as ReactComponent };